import templateUrl from './keyword-search.html';

angular
    .module('festzelt-os.components')
    .component('listviewKeywordSearch', {
        bindings: {
            keyword: '<',
            onUpdate: '&'
        },
        controller() {
            this.$onInit = () => {
            }
        },
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/components/state-manager/listview/keyword-search/keyword-search.js